import { v4 as uuidv4 } from "uuid";
import { isEmptyOrSpaces } from "../shared/helpers/helpers";
import { validation } from "../shared/constants";

export interface IPerson {
    [key: string]: any;

    readonly key: string;
    name: string;
    email: string;
    readonly isNew: boolean;

    validatePerson: () => { isValid: boolean; invalidFields: string[] };
    validateName: () => boolean;
    validateEmail: () => boolean;
}

export class Person implements IPerson {
    [key: string]: any;

    readonly key: string;
    name: string;
    email: string;
    readonly isNew: boolean;

    protected constructor(name: string, email: string, isNew?: boolean) {
        this.key = uuidv4();
        this.name = name ?? "";
        this.email = email ?? "";
        this.isNew = isNew ?? true;
    }

    static New(): Person {
        return new Person("", "", true);
    }

    static Existing(name: string, email: string): Person {
        return new Person(name, email, false);
    }

    validatePerson(): { isValid: boolean; invalidFields: string[] } {
        const invalidFields = [];

        if (!this.validateName()) {
            invalidFields.push("name");
        }

        if (!this.validateEmail()) {
            invalidFields.push("email");
        }

        return { isValid: invalidFields.length === 0, invalidFields: invalidFields };
    }

    validateName(): boolean {
        return !isEmptyOrSpaces(this.name ?? "");
    }

    validateEmail(): boolean {
        return this.email.length > 0 && !!this.email.match(validation.emailRegExp);
    }
}
